import { lazy } from 'react';

const Sectors = lazy(() => import('./Sectors'));

export default Sectors;
